/**
 * File: src/utils/json-tree-builder.js
 * Mô tả: Tiện ích đọc và cập nhật các đường dẫn thuộc tính lồng nhau (Nested object paths) cho dữ liệu JSON.
 * Liên quan: src/components/admin-nested-editor.js, src/components/admin-config-editor.js
 */

/**
 * Lấy giá trị lồng nhau từ chuỗi path (VD: 'unit_progression.champion.hp_multiplier')
 * @param {Object} obj 
 * @param {string} path 
 * @param {*} defaultValue 
 * @returns {*}
 */
export const getNestedValue = (obj, path, defaultValue = undefined) => {
  if (!obj || !path) return defaultValue;
  const keys = path.split('.');
  let current = obj;
  for (const key of keys) {
    if (current && typeof current === 'object' && key in current) {
      current = current[key];
    } else {
      return defaultValue;
    }
  }
  return current;
};

/**
 * Gán giá trị lồng nhau theo chuỗi path
 * @param {Object} obj 
 * @param {string} path 
 * @param {*} value 
 */
export const setNestedValue = (obj, path, value) => {
  if (!obj || !path) return;
  const keys = path.split('.');
  let current = obj;
  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    if (!current[key] || typeof current[key] !== 'object') {
      current[key] = {};
    }
    current = current[key];
  }
  current[keys[keys.length - 1]] = value;
};
